import * as Yup from "yup";
import { ShipmentMethodEnum } from "core/enum/shipment-method.enum";

const selectSchema = Yup.object({
  value: Yup.number().required(),
  label: Yup.string().required(),
});

const isPost = (shipmentMethod: any) =>
  shipmentMethod?.value === ShipmentMethodEnum.Post;

export const CartFormValidation = Yup.object({

  paymentType: selectSchema
    .required("روش پرداخت الزامی است")
    .typeError("روش پرداخت را انتخاب کنید"),

  shipmentMethod: selectSchema
    .required("روش ارسال الزامی است")
    .typeError("روش ارسال را انتخاب کنید"),


  province: selectSchema.when("shipmentMethod", (shipmentMethod, schema) =>
    isPost(shipmentMethod)
      ? schema.required("استان الزامی است").typeError("استان را انتخاب کنید")
      : schema.nullable().notRequired()
  ),

  county: selectSchema.when("shipmentMethod", (shipmentMethod, schema) =>
    isPost(shipmentMethod)
      ? schema
          .required("شهرستان الزامی است")
          .typeError("شهرستان را انتخاب کنید")
      : schema.nullable().notRequired()
  ),

  postalCode: Yup.string().when("shipmentMethod", (shipmentMethod, schema) =>
    isPost(shipmentMethod)
      ? schema
          .required("کد پستی الزامی است")
          .matches(/^[0-9]{10}$/, "کد پستی باید ۱۰ رقم باشد")
      : schema.nullable().notRequired()
  ),

  address: Yup.string().when("shipmentMethod", (shipmentMethod, schema) =>
    isPost(shipmentMethod)
      ? schema.required("آدرس الزامی است")
      : schema.nullable().notRequired()
  ),


  city: Yup.lazy((_, ctx) => {
    const { shipmentMethod, rural } = ctx.parent;

    if (!isPost(shipmentMethod)) {
      return Yup.mixed().nullable().notRequired();
    }

    if (!rural) {
      return Yup.object({
        value: Yup.number().required(),
        label: Yup.string().nullable(),
      })
        .required("شهر را انتخاب کنید")
        .typeError("شهر را انتخاب کنید");
    }

    return Yup.mixed().nullable().notRequired();
  }),

  village: Yup.lazy((_, ctx) => {
    const { shipmentMethod, rural } = ctx.parent;

    if (!isPost(shipmentMethod)) {
      return Yup.mixed().nullable().notRequired();
    }

    if (rural && rural.value !== 0) {
      return Yup.object({
        value: Yup.number().required(),
        label: Yup.string().nullable(),
      })
        .required("روستا را انتخاب کنید")
        .typeError("روستا را انتخاب کنید");
    }

    return Yup.mixed().nullable().notRequired();
  }),
});
export const AddToCartValidation = Yup.object({
  storeProduct: selectSchema
    .required("اتاق الزامی است")
    .typeError("اتاق را انتخاب کنید"),
});
